/* eslint-disable no-shadow */
import PingSessionProxy from '@/proxies/PingSessionProxy';

export const getDefaultState = () => ({
  hasPin: false,
  editItems: [],
  isProfileTypeCategories: false,
  isChanged: false,
});

export const state = getDefaultState();

export const types = {
  RESET: 'RESET',
  SET_HAS_PIN: 'SET_HAS_PIN',
  SET_EDIT_ITEMS: 'SET_EDIT_ITEMS',
  UPDATE_ITEM: 'UPDATE_ITEM',
  SET_CHANGED: 'SET_CHANGED',
  SET_PROFILE_TYPE_CATEGORIES: 'SET_PROFILE_TYPE_CATEGORIES',
};

export const mutations = {
  [types.RESET](state) {
    Object.assign(state, getDefaultState());
  },

  [types.SET_HAS_PIN](state, hasPin) {
    state.hasPin = hasPin;
  },

  [types.SET_EDIT_ITEMS](state, editItems) {
    state.editItems = editItems;
  },

  [types.UPDATE_ITEM](state, { items, editItem }) {
    const someBarred = items.some(item => item.isBarred);
    const someUnbarred = items.some(item => !item.isBarred);

    editItem.items = items;
    if (someBarred && someUnbarred) {
      editItem.hasExceptions = true;
    } else {
      editItem.hasExceptions = false;
      editItem.isBarred = someBarred;
    }
  },

  [types.SET_CHANGED](state, isChanged) {
    state.isChanged = isChanged;
  },

  [types.SET_PROFILE_TYPE_CATEGORIES](state, isProfileTypeCategories) {
    state.isProfileTypeCategories = isProfileTypeCategories;
  },
};

export const getters = {};

export const actions = {
  setHasPin({ commit }, hasPin) {
    commit(types.SET_HAS_PIN, hasPin);
  },

  setEditItems({ commit }, editItems) {
    commit(types.SET_EDIT_ITEMS, editItems);
  },

  updateItem({ commit }, params) {
    commit(types.UPDATE_ITEM, params);
  },

  setProfileTypeCategories({ commit }, isProfileTypeCategories) {
    commit(types.SET_PROFILE_TYPE_CATEGORIES, isProfileTypeCategories);
  },

  async setChanged({ commit }, isChanged) {
    await new PingSessionProxy().all();
    commit(types.SET_CHANGED, isChanged);
  },

  reset({ commit }) {
    commit(types.RESET);
  },
};
